import { EMPTY_FUNCTION } from '@/data/config/FUNC';
import { createContext, useContext, useState } from 'react';

interface BeneficiarySubmissionContextProps {
	open: boolean;
	onOpen: () => void;
	onClose: () => void;
}

const BeneficiarySubmissionContext = createContext<BeneficiarySubmissionContextProps>({
	open: false,
	onOpen: EMPTY_FUNCTION,
	onClose: EMPTY_FUNCTION,
});

export const useBeneficiarySubmissionContext = () => {
	const context = useContext(BeneficiarySubmissionContext);
	if (!context) {
		throw new Error(
			'useBeneficiarySubmissionContext must be used within a BeneficiarySubmissionProvider'
		);
	}
	return context;
};

export const BeneficiarySubmissionProvider = ({ children }: { children: React.ReactNode }) => {
	const [open, setOpen] = useState(false);

	return (
		<BeneficiarySubmissionContext.Provider
			value={{ open, onOpen: () => setOpen(true), onClose: () => setOpen(false) }}
		>
			{children}
		</BeneficiarySubmissionContext.Provider>
	);
};
